export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/gq7oKdEvPYFRNJvdL3sEKZ/IMG_2584.jpg',
    alt: 'Sample page: What Is Hydrogen Energy? Hydrogen as a material, an industrial feedstock and an energy carrier',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wCCmo4fhNz4Wqvvjjun8w9/IMG_2585.jpg',
    alt: 'Sample page: Electricity-to-Hydrogen Conversion, explaining how water electrolysis splits water into hydrogen and oxygen',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cWVAqZotcmprxrHek3xKqK/IMG_2586.jpg',
    alt: 'Sample page: Hydrogen vs. Battery Storage, comparing round-trip efficiency, storage scale and duration',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vyezkv4XfouA4AkG72mPmd/IMG_2587.jpg',
    alt: 'Sample page: Hydrogen as Long-Duration Storage, showing underground hydrogen storage in a salt cavern',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3rSAoHRAwioTJG4LEQqD5n/IMG_2588.jpg',
    alt: 'Sample page: Fuel Cells vs. Combustion, explaining electrochemical conversion of hydrogen to electricity',
  },
];
